import { HTMLProps, forwardRef, memo } from 'react';
import styles from '../styles/HtsButtonIcon.module.scss';

export const HtsButtonIcon = memo(
  forwardRef<HTMLButtonElement, HTMLProps<HTMLButtonElement>>(
    ({ children, className, ...props }, ref) => (
      <button {...props} ref={ref} type="button" className={`${styles.container} ${className}`}>
        {children}
      </button>
    )
  )
);
